import ManagementService from "../../services";
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";
import { hasError } from "@/utils/utils";
export default {
  namespaced: true,
  state: {
    contactInfo: [],
    ngo: { info: {}, contacts: [] },
    branches: [],
    loading: false,
    isSaving: false,
    isDeleting: false,
  },
  getters: {
    contactInfo(state) {
      return state.contactInfo;
    },
    branches(state) {
      return state.branches;
    },
    ngo(state) {
      return state.ngo;
    },
    loading(state) {
      return state.loading;
    },
    isSaving(state) {
      return state.isSaving;
    },
    isDeleting(state) {
      return state.isDeleting;
    },
  },
  mutations: {
    setNgoContactInfo(state, val) {
      state.ngo = val;
    },
    setBranchesContactInfo(state, val) {
      state.branches = val;
    },
    setLoading(state, val) {
      state.loading = val;
    },
    setIsSaving(state, val) {
      state.isSaving = val;
    },
    setIsDeleting(state, val) {
      state.isDeleting = val;
    },
  },
  actions: {
    async updateContact({ commit, dispatch }, payload) {
      commit("setIsSaving", true);
      try {
        const res = await ManagementService.updateContactInfo(payload);
        if (hasError(res.status)) throw res.status;

        this._vm.$toast({
          component: ToastificationContent,
          props: {
            title: "تم تعديل المعلومات بنجاح",
            icon: "CheckSquareIcon",
            variant: "success",
          },
        });
        await dispatch("fetchContactInfo");

        return Promise.resolve(res);
      } catch (err) {
        this._vm.$toast({
          component: ToastificationContent,
          props: {
            title: "حدث خطأ أثناء تعديل المعلومات",
            icon: "AlertCircleIcon",
            variant: "danger",
          },
        });
        return Promise.reject(err);
      } finally {
        commit("setIsSaving", false);
      }
    },
    async saveContact({ commit, dispatch }, data) {
      commit("setIsSaving", true);
      try {
        const res = await ManagementService.saveContactInfo(data);
        if (hasError(res.status)) throw res.status;
        this._vm.$toast({
          component: ToastificationContent,
          props: {
            title: "تمت إضافة معلومات التواصل بنجاح",
            icon: "CheckSquareIcon",
            variant: "success",
          },
        });
        await dispatch("fetchContactInfo");
        return Promise.resolve(res);
      } catch (err) {
        this._vm.$toast({
          component: ToastificationContent,
          props: {
            title: "حدث خطأ أثناء إضافة المعلومات",
            icon: "AlertCircleIcon",
            variant: "danger",
          },
        });
        return Promise.reject(err);
      } finally {
        commit("setIsSaving", false);
      }
    },
    async deleteContact({ commit, dispatch }, payload) {
      commit("setIsDeleting", true);
      try {
        const res = await ManagementService.deleteContactInfo(payload);
        if (hasError(res.status)) throw res.status;

        this._vm.$toast({
          component: ToastificationContent,
          props: {
            title: "تم حذف معلومات التواصل بنجاح",
            icon: "CheckSquareIcon",
            variant: "success",
          },
        });
        await dispatch("fetchContactInfo");
        return Promise.resolve(res);
      } catch (err) {
        this._vm.$toast({
          component: ToastificationContent,
          props: {
            title: "حدث خطأ أثناء حذف المعلومات",
            icon: "AlertCircleIcon",
            variant: "danger",
          },
        });
        return Promise.reject(err);
      } finally {
        commit("setIsDeleting", false);
      }
    },
    async fetchContactInfo({ commit }) {
      commit("setLoading", true);
      try {
        const data = await ManagementService.fetchContactInfo();
        commit("setNgoContactInfo", data.data.ngo);
        commit("setBranchesContactInfo", data.data.branches);
      } catch (err) {
      } finally {
        commit("setLoading", false);
      }
    },
  },
};
